import React from "react"
import Button from "@kit/design/button"
import analytics from "utils/analytics"

export default function TrialNav({ userInfo, daysLeft }) {
  const showCountdown = userInfo.trialing
  const showUpgradeButton = userInfo.trialing

  return (
    <React.Fragment>
      <div className="flex items-center">
        {showCountdown && (
          <div className="my-auto mx-5 text-black">
            Trial: {daysLeft} remaining
          </div>
        )}

        {showUpgradeButton && (
          <Button is="primary" size="sm" href="/upgrade" onClick={trackClick}>
            <span className="inline xl:hidden">Upgrade</span>
            <span className="hidden xl:inline">Upgrade now</span>
          </Button>
        )}
      </div>
    </React.Fragment>
  )
}
const trackClick = () => {
  analytics.track(
    "Element",
    "Clicked",
    {
      name: "header_upgrade_now",
      text: "Upgrade now"
    },
    { transport: "beacon" }
  )
}
